import { UtilsService } from './../utils.service';
import { Component, OnInit } from "@angular/core";
import { ServiceService } from "../service.service";
import { AlertController, LoadingController, Platform } from "@ionic/angular";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import moment from "moment";
import { Router } from "@angular/router";

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { HttpErrorResponse } from '@angular/common/http';
import { AppVersion } from '@ionic-native/app-version/ngx';
// import { Device } from '@ionic-native/device/ngx';




@Component({
  selector: "app-login",
  templateUrl: "./login.page.html",
  styleUrls: ["./login.page.scss", "../../assets/scss/styles.scss"],
})
export class LoginPage implements OnInit {
  email: any;
  password: any;
  checkBRemember: boolean;
  isWeb:boolean = false;
  versionServer = -1;
  versionLocal:any = "4.2.9";
  lockButton:boolean = true;

  constructor(
    public services: ServiceService,
    public alertController: AlertController,
    private router: Router,
    public utils: UtilsService,
    private firebaseAnalytics: FirebaseAnalytics,
    private platform: Platform,
    private appVersion: AppVersion,
    private loadingController: LoadingController
    // private device: Device
  ) {
    this.checkBRemember = true;
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Login");
    this.isWeb = !this.services.isMovil();

  }

  ngOnInit() {
    this.email = localStorage.getItem("emailsession");
    this.password = localStorage.getItem("passwordsession");
    this.checkVersion();
    this.getPromocionesByZone();
    //Solicitando app tracking solo para iOS
    /* if(this.platform.is('ios') && this.device.version >= '14.5'){
      this.requestAppTracking();
    } */
  }

  onSubmit() {
    
    this.services.login(this.email, this.password,this.versionLocal).subscribe(
      async (data) => {
        if (data["status"] === 401) {
          const alert = await this.alertController.create({
            header: "",
            subHeader: "",
            message: "Por favor intenta de Nuevo - Code 401",
            buttons: ["OK"],
          });

          await alert.present();
          await alert.onDidDismiss();
        } else {
          // Credentials in local storage
          if (this.checkBRemember) {
            localStorage.setItem("emailsession", this.email);
            localStorage.setItem("passwordsession", this.password);
            
          } else {
            localStorage.setItem("emailsession", "");
            localStorage.setItem("passwordsession", "");
          }

          // Save in Storage
          localStorage.setItem("accesNew", "1");
          localStorage.setItem("idUser", data["idUser"]);
          localStorage.setItem("token", data["token"]);
          localStorage.setItem("imageUrl", data["imageUrl"]);
          localStorage.setItem("completeName", data["completeName"]);
          localStorage.setItem("roleId", data["roleId"]);

          this.utils.isLogged = true;
          
          this.router.navigate(["/bienvenido"],{ replaceUrl: true });
          if(this.isWeb) window.location.reload();
        }
      },
      async (error : any) => {
        console.log(error);
        let mensage = error.message;//"Por favor intenta de Nuevo";
        if(error instanceof HttpErrorResponse){
          switch(error.status){
            case 400:
            case 403:
            case 401:
            case 500:
              mensage = error.error;
              break;
          }
        }
        

        const alert = await this.alertController.create({
          header: "",
          subHeader: "",
          message: mensage,
          buttons: ["OK"],
        });

        await alert.present();
        await alert.onDidDismiss();
      }
    );
  }

  goto(url:string) {
    this.router.navigate([url], { replaceUrl: true });
  }

  public checkVersion(){
    if(this.isWeb){
      this.lockButton = false;
      this.versionLocal = "4.2.9";
      return;
    }
    this.appVersion.getVersionNumber().then((version : any) => {
      
      if (version != null) {
        //this.versionLocal = this.convertoInt(version);
        this.versionLocal = version;
        //this.versionLocal = "4.2.9";
        //this.getVersionActualApp();
      }
      
      
    }).catch(async (error : any ) => {
      console.log(error);
      //this.getVersionActualApp(); // para testing especifico
      const alert = await this.alertController.create({
        header: "Error generado",
        subHeader: "",
        message: error,
        buttons: ["OK"],
      });

      await alert.present();
      await alert.onDidDismiss();
      
    });
    
  }

  public getVersionActualApp(){
    this.services.getAppVersion()
    .then((response : any ) => {
      
      if (response != null) {
        if(response.hasOwnProperty('appVersion')  )
        {
          this.versionServer = this.convertoInt(String(response.appVersion));
          if (this.versionLocal == this.versionServer && (this.versionLocal != -1 && this.versionServer != -1) ) {
            this.updateUI(false);
          } else {
            this.updateUI(true);
          }
        }
         
      }else{
        this.showAlert("Para iniciar sesión es necesario actualizar la aplicación");
      }
    }).catch((error : any ) => {
      this.showAlert("Ocurrió un error al obtener version de app");
    });
  }

  public async showAlert(message : string = ""){
    const alert = await this.alertController.create({
      header: "",
      subHeader: "",
      message: message,
      buttons: ["OK"],
    });

    await alert.present();
  }

  public convertoInt(version : string){
    try {
      return parseInt(version.replace(/(\.)/g,''));
    } catch (error) {
      return 0;
    }
    
  }

  public updateUI(valor : boolean){
    this.lockButton = valor;
    if(valor){
      this.showAlert("Para iniciar sesión es necesario actualizar la aplicación");
    }
  }



  public requestAppTracking(){

    this.platform.ready().then(() => {
      let cordova:any = window['cordova']; 
      const idfaPlugin = cordova.plugins.idfa;

      idfaPlugin.getInfo()
          .then(info => {
              if (!info.trackingLimited) {
                  return info.idfa || info.aaid;
              } else if (info.trackingPermission === idfaPlugin.TRACKING_PERMISSION_NOT_DETERMINED) {
                  return idfaPlugin.requestPermission().then(result => {
                      if (result === idfaPlugin.TRACKING_PERMISSION_AUTHORIZED) {
                          return idfaPlugin.getInfo().then(info => {
                              return info.idfa || info.aaid;
                          });
                      }
                  });
              }
          })
          .then(idfaOrAaid => {
              if (idfaOrAaid) {
                  console.log(idfaOrAaid);
              }
          })

    });

;


  }


  public win(res) {
    console.log('success ' + JSON.stringify(res));
  }
  public fail(res) {
    console.log('fail ' + JSON.stringify(res));
  }

  onLoadStart(video:any) {
    this.loading.dismiss();
  }

  promociones:any = [];
  objetoBanner:any = {};
  loading:HTMLIonLoadingElement;
  public async  getPromocionesByZone(){
    this.loading = await this.loadingController.create({
      message: 'Espere por favor ...', duration: 6000
    });
  
    await this.loading.present();

    let idZone = this.isWeb ? 11 : 10;
    (await this.services.getPromosByZone(idZone)).toPromise()
    .then((response : any ) => {
      if (Array.isArray(response) ) {
        this.promociones = response;
        if(this.promociones.length > 0){
          this.objetoBanner = this.promociones[0];
        }else{
          this.objetoBanner = {};
        }
      }else{
        this.promociones = [];
        this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
      }
    }).catch((error : any ) => {
      this.loading.dismiss();
      this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
    });


  }

  public getFileExtension(fileName: string = "") {
    return fileName.substring(fileName.lastIndexOf('.') + 1);
  }

}